/* tslint:disable */
/* eslint-disable */
/**
 * RakuLogi API
 * RakuLogi の API ドキュメント
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface ResponseSyncItemsStatusResponse
 */
export interface ResponseSyncItemsStatusResponse {
    /**
     * 同期中かどうか
     * @type {boolean}
     * @memberof ResponseSyncItemsStatusResponse
     */
    isSyncing?: boolean;
    /**
     * 直近の同期結果（success / error / not_connected）。同期開始時にクリアされる
     * @type {string}
     * @memberof ResponseSyncItemsStatusResponse
     */
    result?: string;
    /**
     * 同期失敗時のエラー内容
     * @type {string}
     * @memberof ResponseSyncItemsStatusResponse
     */
    message?: string;
    /**
     * 取り込んだ件数
     * @type {number}
     * @memberof ResponseSyncItemsStatusResponse
     */
    importedCount?: number;
    /**
     * 自己配送のため除外した件数
     * @type {number}
     * @memberof ResponseSyncItemsStatusResponse
     */
    skippedCount?: number;
    /**
     * 同期の完了日時
     * @type {string}
     * @memberof ResponseSyncItemsStatusResponse
     */
    finishedAt?: string;
}

/**
 * Check if a given object implements the ResponseSyncItemsStatusResponse interface.
 */
export function instanceOfResponseSyncItemsStatusResponse(value: object): value is ResponseSyncItemsStatusResponse {
    return true;
}

export function ResponseSyncItemsStatusResponseFromJSON(json: any): ResponseSyncItemsStatusResponse {
    return ResponseSyncItemsStatusResponseFromJSONTyped(json, false);
}

export function ResponseSyncItemsStatusResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseSyncItemsStatusResponse {
    if (json == null) {
        return json;
    }
    return {

        'isSyncing': json['is_syncing'] == null ? undefined : json['is_syncing'],
        'result': json['result'] == null ? undefined : json['result'],
        'message': json['message'] == null ? undefined : json['message'],
        'importedCount': json['imported_count'] == null ? undefined : json['imported_count'],
        'skippedCount': json['skipped_count'] == null ? undefined : json['skipped_count'],
        'finishedAt': json['finished_at'] == null ? undefined : json['finished_at'],
    };
}

export function ResponseSyncItemsStatusResponseToJSON(json: any): ResponseSyncItemsStatusResponse {
    return ResponseSyncItemsStatusResponseToJSONTyped(json, false);
}

export function ResponseSyncItemsStatusResponseToJSONTyped(value?: ResponseSyncItemsStatusResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {

        'is_syncing': value['isSyncing'],
        'result': value['result'],
        'message': value['message'],
        'imported_count': value['importedCount'],
        'skipped_count': value['skippedCount'],
        'finished_at': value['finishedAt'],
    };
}
